import appConfig from '../../config/appConfig';
import FactsheetDataModels from '@/api/FactsheetDataModels';
import AssetTypes from '../../api/AssetTypes';
import ClientsideLocations from '../../api/ClientsideLocations';
import ClientsideFacilities from '../../api/ClientsideFacilities';

const facilityTemplate = {
  namespaced: true,
  state: {
    title: '',
    imageCaptionText: '',
    facilityOverviewText: '',
    aboutCompanyText: '',
    primaryCompany: '',
    secondaryCompany: '',
    primaryLogo: '',
    secondaryLogo: '',
    primaryWebAddress: '',
    secondaryWebAddress: '',
    primaryImage: '',
    longImage: '',
    linkToFactSheet: '',
    companyInfos: '',
    disclaimer1: '',
    facilityTechType: null,
    facilityFactoids: [{}],
    profileLoaded: false,
    facilityData: null,
    facilityLoaded: false,
    techData: {},
    techFuelType: '',
    techTitle: '',
    techImage: '',
    techOverview: '',
    techBenefits: '',
    techDisclaimer1: '',
    techDisclaimer2: '',
    techDisclaimer3: ''
  },
  mutations: {
    setTitle: (state, value) => {
      state.title = value;
    },
    setImageCaptionText: (state, value) => {
      state.imageCaptionText = value;
    },
    setFacilityOverviewText: (state, value) => {
      state.facilityOverviewText = value;
    },
    setFacilityTechType: (state, value) => {
      state.facilityTechType = value;
    },
    setAboutCompanyText: (state, value) => {
      state.aboutCompanyText = value;
    },
    setPrimaryCompany: (state, value) => {
      state.primaryCompany = value;
    },
    setSecondaryCompany: (state, value) => {
      state.secondaryCompany = value;
    },
    setPrimaryLogo: (state, value) => {
      state.primaryLogo = value;
    },
    setSecondaryLogo: (state, value) => {
      state.secondaryLogo = value;
    },
    setPrimaryWebAddress: (state, value) => {
      state.primaryWebAddress = value;
    },
    setSecondaryWebAddress: (state, value) => {
      state.secondaryWebAddress = value;
    },
    setPrimaryImage: (state, value) => {
      state.primaryImage = value;
    },
    setLongImage: (state, value) => {
      state.longImage = value;
    },
    setLinkToFactSheet: (state, value) => {
      state.linkToFactSheet = value;
    },
    setCompanyInfos: (state, value) => {
      state.companyInfos = value;
    },
    setDisclaimer1: (state, value) => {
      state.disclaimer1 = value;
    },
    setFactoidsState: (state, value) => {
      state.factoidsState = value;
    },
    setProfileLoaded: (state, value) => {
      state.profileLoaded = value;
    },
    setFacilityData: (state, value) => {
      state.facilityData = value;
    },
    setFacilityFactoids: (state, value) => {
      state.facilityFactoids = value;
    },
    setFacilityLoaded: (state, value) => {
      state.facilityLoaded = value;
    },
    setTechData: (state, value) => {
      state.techData = value;
    },
    setTechFuelType: (state, value) => {
      state.techFuelType = value;
    },
    setTechTitle: (state, value) => {
      state.techTitle = value;
    },
    setTechImage: (state, value) => {
      state.techImage = value;
    },
    setTechOverview: (state, value) => {
      state.techOverview = value;
    },
    setTechBenefits: (state, value) => {
      state.techBenefits = value;
    },
    setTechDisclaimer1: (state, value) => {
      state.techDisclaimer1 = value;
    },
    setTechDisclaimer2: (state, value) => {
      state.techDisclaimer2 = value;
    },
    setTechDisclaimer3: (state, value) => {
      state.techDisclaimer3 = value;
    }
  },
  getters: {
    title: (state) => {
      return state.title;
    },
    imageCaptionText: (state) => {
      return state.imageCaptionText;
    },
    facilityOverviewText: (state) => {
      return state.facilityOverviewText;
    },
    facilityTechType: (state) => {
      return state.facilityTechType;
    },
    aboutCompanyText: (state) => {
      return state.aboutCompanyText;
    },
    primaryCompany: (state) => {
      return state.primaryCompany;
    },
    secondaryCompany: (state) => {
      return state.secondaryCompany;
    },
    primaryLogo: (state) => {
      return state.primaryLogo;
    },
    secondaryLogo: (state) => {
      return state.secondaryLogo;
    },
    primaryWebAddress: (state) => {
      return state.primaryWebAddress;
    },
    secondaryWebAddress: (state) => {
      return state.secondaryWebAddress;
    },
    primaryImage: (state) => {
      return state.primaryImage;
    },
    longImage: (state) => {
      return state.longImage;
    },
    linkToFactSheet: (state) => {
      return state.linkToFactSheet;
    },
    companyInfos: (state) => {
      return state.companyInfos;
    },
    disclaimer1: (state) => {
      return state.disclaimer1;
    },
    factoidsState: (state) => {
      return state.factoidsState;
    },
    profileLoaded: (state) => {
      return state.profileLoaded;
    },
    facilityData: (state) => {
      return state.facilityData;
    },
    facilityFactoids: (state) => {
      return state.facilityFactoids;
    },
    facilityLoaded: (state) => {
      return state.facilityLoaded;
    },
    techData: (state) => {
      return state.techData;
    },
    techFuelType: (state) => {
      return state.techFuelType;
    },
    techTitle: (state) => {
      return state.techTitle;
    },
    techImage: (state) => {
      return state.techImage;
    },
    techOverview: (state) => {
      return state.techOverview;
    },
    techBenefits: (state) => {
      return state.techBenefits;
    },
    techDisclaimer1: (state) => {
      return state.techDisclaimer1;
    },
    techDisclaimer2: (state) => {
      return state.techDisclaimer2;
    },
    techDisclaimer3: (state) => {
      return state.techDisclaimer3;
    }
  },
  actions: {
    initializeFacilityTemplate: ({ commit, state, rootGetters }) => {
      const facilityDefaultProfile =
        rootGetters['profileConfig/facilityDefaultProfile'];
      const profile = facilityDefaultProfile.templates[0];

      const getValue = (value) => state.facilityData.attributes[value];

      const setTechData = (dataType) => {
        const facilityTechData = state.techData.find(
          (data) => data.FUEL_TYPE_DESC.toUpperCase() === dataType.toUpperCase()
        );
        const getTechValue = (value) => facilityTechData[value];
        const keyValues = appConfig.techData.outFields;
        if (facilityTechData) {
          commit('setTechFuelType', getTechValue(keyValues[0]));
          commit('setTechTitle', getTechValue(keyValues[1]));
          commit('setTechImage', getTechValue(keyValues[2]));
          commit('setTechOverview', getTechValue(keyValues[3]));
          commit('setTechBenefits', getTechValue(keyValues[4]));
          commit('setTechDisclaimer1', getTechValue(keyValues[5]));
          commit('setTechDisclaimer2', getTechValue(keyValues[6]));
          commit('setTechDisclaimer3', getTechValue(keyValues[7]));
        }
      };

      const loadData = async () => {
        if (profile) {
          profile.titleField
            ? commit('setTitle', getValue(profile.titleField))
            : commit('setTitle', null);

          profile.facilityTechType
            ? commit(
              'setFacilityTechType',
              await getValue(profile.facilityTechType)
            )
            : commit('setFacilityTechType', 'default');

          setTechData(state.facilityTechType);

          profile.imageCaptionTextField
            ? commit(
              'setImageCaptionText',
              await getValue(profile.imageCaptionTextField)
            )
            : commit('setImageCaptionText', null);

          profile.facilityOverviewTextField
            ? commit(
              'setFacilityOverviewText',
              await getValue(profile.facilityOverviewTextField)
            )
            : commit('setFacilityOverviewText', null);

          profile.aboutCompanyTextField
            ? commit(
              'setAboutCompanyText',
              await getValue(profile.aboutCompanyTextField)
            )
            : commit('setAboutCompanyText', null);

          profile.primaryCompanyField
            ? commit(
              'setPrimaryCompany',
              await getValue(profile.primaryCompanyField)
            )
            : commit('setPrimaryCompany', null);

          profile.secondaryCompanyField
            ? commit(
              'setSecondaryCompany',
              await getValue(profile.secondaryCompanyField)
            )
            : commit('setSecondaryCompany', null);

          profile.primaryLogoField
            ? commit('setPrimaryLogo', await getValue(profile.primaryLogoField))
            : commit('setPrimaryLogo', null);

          profile.secondaryLogoField
            ? commit(
              'setSecondaryLogo',
              await getValue(profile.secondaryLogoField)
            )
            : commit('setSecondaryLogo', null);

          profile.primaryWebAddressField
            ? commit(
              'setPrimaryWebAddress',
              getValue(profile.primaryWebAddressField)
            )
            : commit('setPrimaryWebAddress', null);

          profile.secondaryWebAddressField
            ? commit(
              'setSecondaryWebAddress',
              getValue(profile.secondaryWebAddressField)
            )
            : commit('setSecondaryWebAddress', null);

          profile.primaryImageField
            ? commit(
              'setPrimaryImage',
              await getValue(profile.primaryImageField)
            )
            : commit('setPrimaryImage', null);

          profile.longImageField
            ? commit('setLongImage', await getValue(profile.longImageField))
            : commit('setLongImage', null);

          profile.linkToFactSheetField
            ? commit(
              'setLinkToFactSheet',
              getValue(profile.linkToFactSheetField)
            )
            : commit('setLinkToFactSheet', null);

          profile.companyInfos
            ? commit('setCompanyInfos', profile.companyInfos)
            : commit('setCompanyInfos', null);

          profile.disclaimer1
            ? commit('setDisclaimer1', getValue(profile.disclaimer1))
            : commit('setDisclaimer1', null);

          const factoids = state.facilityData.updatedFactoids;
          profile.facilityFactoids
            ? commit('setFacilityFactoids', factoids)
            : commit('setFacilityFactoids', null);

          commit('setProfileLoaded', true);
        }
      };
      loadData();
    },
    async selectFacility(
      { commit, rootGetters, rootMutations, dispatch },
      facility
    ) {
      let data;
      const facilities = new ClientsideFacilities(appConfig.facilityApiProps);
      const facilityFeatureLayer =
        rootGetters['mapTemplate/facilityFeatureLayer'];
      const facilityDefaultProfile =
        rootGetters['profileConfig/facilityDefaultProfile'];
      const profile = facilityDefaultProfile.templates[0];

      const facilityImageLinkField = profile.primaryImageField;
      const facilityLongImageLinkField = profile.longImageField;
      const facilityLinkToFactsheetField = profile.linkToFactSheetField;
      const facilityFactoids = profile.facilityFactoids;
      const facilityFields = profile.outFields;
      const techType = profile.facilityTechType;

      data = await facilities
        .getFacilityInfoByName(
          facilityFeatureLayer,
          facility,
          facilityImageLinkField,
          facilityLinkToFactsheetField,
          techType,
          facilityFactoids,
          facilityFields
        )
        .catch((err) => {
          console.log(err);
          commit('setError', err, {
            root: true
          });
        });
      if (data) {
        commit('setFacilityData', data);
        commit('setFacilityLoaded', true);
        commit('mapTemplate/setSelectedItemType', 'Facility', { root: true });
        commit('mapTemplate/setSelectedItemValue', facility, { root: true });
        dispatch('initializeFacilityTemplate');
      } else {
        commit('setFacilityData', null);
        commit('setFacilityLoaded', false);
      }
    }
  }
};

export default facilityTemplate;
